import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { isServer } from "shared/constants/isServer";
import styled from "styled-components";

interface Props {
    title: string,
    text: string,
    subtext?: string,
    fullText?: boolean,
}

const Wrapper = styled(FlexBox)`
    max-width: 480px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       max-width: 400px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        .info-wrapper{
            transform: translate(0%, 50%);
        }
        max-width: 320px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 300px;
    }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    font-weight: 600;
    color: #151514;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
        margin-bottom: 12px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 10px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 8px;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    font-weight: 400;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

const SubText = styled.div`
    font-family: 'Inter';
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    font-weight: 600;
    color: #151514;
    margin-top: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
        margin-top: 12px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 17px;
    }
`;

const SubmitButton = styled.button<{ hide?: boolean }>`
    cursor: pointer;
    background-color: #151514;
    color: #fff;
    padding: 12px 42px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 600;
    line-height: 19px;
    -webkit-letter-spacing: -0.02em;
    -moz-letter-spacing: -0.02em;
    -ms-letter-spacing: -0.02em;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
    max-width: 240px;
    border-color: transparent;
    margin-top: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 10px 36px;
        font-size: 14px;
        line-height: 18px;
        max-width: 220px;
        margin-top: 20px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding: 9px 28px;
        font-size: 12px;
        line-height: 16px;
        max-width: 180px;
        margin-top: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 8px 24px;
        font-size: 12px;
        line-height: 16px;
        max-width: 160px;
        margin-top: 14px;
    }
`;

export const CustomInfoModal: FC<Props> = ({ title, text, subtext, fullText}) => {
    const handleNominationsClick = () => {
        window.open('https://green-award.ru/nominations?tab=greenaward', '_self');
    };

    return (
        <Wrapper 
            align={'center'} 
            alignMobile="center" 
            direction="column" 
            directionMobile="column" 
            width={'100%'} 
            widthMobile={'100%'}
            className={'info-wrapper'}
        >
            <Title>{title}</Title>
            <Text>{text}</Text>
            {fullText && <SubText>{subtext}</SubText>}
            {fullText && !isServer && <SubmitButton onClick={handleNominationsClick}>К номинациям</SubmitButton>}
        </Wrapper>
    );
}import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { isServer } from "shared/constants/isServer";
import styled from "styled-components";

interface Props {
    title: string,
    text: string,
    subtext?: string,
    fullText?: boolean,
}

const Wrapper = styled(FlexBox)`
    max-width: 480px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       max-width: 400px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        .info-wrapper{
            transform: translate(0%, 50%);
        }
        max-width: 320px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: 300px;
    }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    font-weight: 600;
    color: #151514;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
        margin-bottom: 12px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 10px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 8px;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    font-weight: 400;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

const SubText = styled.div`
    font-family: 'Inter';
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    font-weight: 600;
    color: #151514;
    margin-top: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
        margin-top: 12px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 15px;
        line-height: 17px;
    }
`;

const SubmitButton = styled.button<{ hide?: boolean }>`
    cursor: pointer;
    background-color: #151514;
    color: #fff;
    padding: 12px 42px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 600;
    line-height: 19px;
    -webkit-letter-spacing: -0.02em;
    -moz-letter-spacing: -0.02em;
    -ms-letter-spacing: -0.02em;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
    max-width: 240px;
    border-color: transparent;
    margin-top: 24px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 10px 36px;
        font-size: 14px;
        line-height: 18px;
        max-width: 220px;
        margin-top: 20px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        padding: 9px 28px;
        font-size: 12px;
        line-height: 16px;
        max-width: 180px;
        margin-top: 16px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        padding: 8px 24px;
        font-size: 12px;
        line-height: 16px;
        max-width: 160px;
        margin-top: 14px;
    }
`;

export const CustomInfoModal: FC<Props> = ({ title, text, subtext, fullText}) => {
    const handleNominationsClick = () => {
        window.open('https://green-award.ru/nominations?tab=greenaward', '_self');
    };

    return (
        <Wrapper 
            align={'center'} 
            alignMobile="center" 
            direction="column" 
            directionMobile="column" 
            width={'100%'} 
            widthMobile={'100%'}
            className={'info-wrapper'}
        >
            <Title>{title}</Title>
            <Text>{text}</Text>
            {fullText && <SubText>{subtext}</SubText>}
            {fullText && !isServer && <SubmitButton onClick={handleNominationsClick}>К номинациям</SubmitButton>}
        </Wrapper>
    );
}